const colorUtils: {
    theme: any,
} = {
    theme: {
        'primary': '#0d6efd',
        'white': '#ffffff',
        'blue': '#273586',
        'blue100': '#273586',
        'blue80': '#2796E7',
        'blue10': '#ECF6FD',
        'blue5': '#F4FAFF',
        'info': '#0dcaf0',

        'gray': '#666666',
        'gray80': '#333333',
        'gray50': '#666666',
        'gray20': '#D9D9D9',

        'yellow': '#F4D526',
        'yellow100': '#F4D526',
        'yellow10': '#FFFDF3',

        'green': '#4CD31C',
        'green100': '#4CD31C',

        'red': '#A10000',
        'red100': '#A10000',

        'orange': '#F47B30',
    }
}

export default colorUtils
